/**
 * Do not edit directly
 */

export default "PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0ibTEwLjUgMTAuNWg1djVoLTV6Ii8+PHBhdGggZD0ibTEyLjUgOWgxdi0yLjVoLTV2LTEuMWEyLjUgMi41IDAgMSAwIC0xIDB2MWgtNXY0YTIuNSAyLjUgMCAxIDAgMSAwdi0yLjloOXoiLz48L3N2Zz4=";